// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"486":"8cc60fee","874":"39e980be"}[chunkId] + ".chunk.css";
};